import type { AutocompleteProps, TextFieldProps } from '@mui/material';
import CheckboxAutocomplete from 'components/common/CheckboxAutocomplete';
import type { OptionValue } from 'components/common/CheckboxAutocomplete';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getGoogleAdAdvertisersOptions } from '../api';
import useFacebookAdsLibraryParams from '../hooks/useFacebookAdsLibraryParams';

interface GoogleAdvertiserAutocompleteProps
  extends Omit<AutocompleteProps<string, true, boolean, false>, 'value' | 'onChange' | 'options' | 'renderInput'> {
  value?: string[];
  onChange: (value: string[]) => void;
  InputProps?: TextFieldProps;
  allowedValues: string[];
}

const GoogleAdvertiserAutocomplete = ({
  InputProps,
  value,
  onChange,
  allowedValues,
  ...props
}: GoogleAdvertiserAutocompleteProps) => {
  const { network, region } = useFacebookAdsLibraryParams();
  const { data } = useSuspenseQuery({
    ...getGoogleAdAdvertisersOptions({ network, region }),
    select: (data) =>
      data
        .map(({ id, name }) => ({ label: name, value: id }))
        .filter(({ value: optionValue }) => allowedValues.includes(optionValue)),
  });

  return (
    <CheckboxAutocomplete
      {...props}
      value={value}
      onChange={onChange as (value: OptionValue[]) => void}
      InputProps={InputProps}
      id="google-advertiser-autocomplete"
      options={data}
    />
  );
};

export default GoogleAdvertiserAutocomplete;
